import { hasDocFlowNoRecipientInDeleteItems } from '../../DocFlow.utils.recipients'
import {
  DOC_FLOW_COMBINING_MASS_ACTION_DELETE,
  DOC_FLOW_COMBINING_MASS_ACTION_EDIT_SEQUENCE_DOCUMENT,
} from '../../DocFlowCombining'

export function isChangedCombinedValue({ item, value }) {
  return (
    (item.permissions.can_make_uncombined && !value) ||
    (item.permissions.can_make_combined && value)
  )
}

export function isUpdateProfileAfterMassDelete({
  action,
  deleteItems,
  response,
  tableItems,
}) {
  return (
    action === DOC_FLOW_COMBINING_MASS_ACTION_DELETE &&
    (response.data.items.length === 0 ||
      hasDocFlowNoRecipientInDeleteItems(tableItems, deleteItems))
  )
}

export function isEditSequenceMassAction(action) {
  return action === DOC_FLOW_COMBINING_MASS_ACTION_EDIT_SEQUENCE_DOCUMENT
}
